/**
 * OrderForm bileşeninde kullanılan yardımcı fonksiyonlar ve stiller
 */

// Sayısal alanlarda negatif işareti ve 'e' karakterini engelle
export const handleNumericKeyDown = (e) => {
  if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
    e.preventDefault();
  }
};

// react-select için stil özelleştirmesi
export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    padding: '0px 4px',
    minHeight: '42px',
    border: state.isFocused ? '1px solid #b04309' : '1px solid #ddd',
    boxShadow: 'none',
    borderRadius: '6px',
    '&:hover': {
      border: state.isFocused ? '1px solid #b04309' : '1px solid #cbd5e1'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '42px',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px',
    padding: '0px',
    'input:focus': {
      boxShadow: 'none !important'
    }
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '6px 12px',
    backgroundColor: state.isSelected ? '#b04309' : state.isFocused ? '#fff5f0' : 'white',
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#333',
  })
};

export const pliseMontajSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '36px',
    height: '36px',
    fontSize: '12px',
    border: state.isFocused ? '1px solid #b04309' : '1px solid #cbd5e1',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(176, 67, 9, 0.1)' : 'none',
    borderRadius: '6px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    '&:hover': {
      borderColor: state.isFocused ? '#b04309' : '#94a3b8'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
    height: '34px'
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '34px'
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#334155',
    fontSize: '12px',
    fontWeight: 500
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '8px 12px',
    fontSize: '12px',
    backgroundColor: state.isSelected ? '#b04309' : state.isFocused ? '#fff5f0' : 'white',
    color: state.isSelected ? 'white' : '#334155',
    cursor: 'pointer'
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    fontSize: '12px'
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999
  })
};
